"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const octicons_react_1 = require("@primer/octicons-react");
const Button_1 = __importDefault(require("components/base/Button"));
const Layout_1 = require("components/base/Layout");
const Text_1 = __importDefault(require("components/base/Text"));
const FilterCollapse_1 = __importDefault(require("components/FilterCollapse"));
const TagColorsModal_1 = __importDefault(require("components/modals/TagColorsModal"));
const SortCollapse_1 = __importDefault(require("components/SortCollapse"));
const UseToggle_1 = __importDefault(require("hooks/UseToggle"));
const Collapse_1 = __importDefault(require("../base/Collapse"));
const Controls_1 = __importDefault(require("../base/Controls"));
const Link_1 = __importDefault(require("../base/Link"));
const ResponsiveDiv_1 = __importDefault(require("../base/ResponsiveDiv"));
const WithModal_1 = __importDefault(require("../WithModal"));
const TagColorsModalItem = (0, WithModal_1.default)(Link_1.default, TagColorsModal_1.default);
const CubeCompareNavbar = ({ cubeA, cubeAID, cubeB, cubeBID, openCollapse, setOpenCollapse, }) => {
    const [expanded, toggleExpanded] = (0, UseToggle_1.default)(false);
    const handleOpenCollapse = (0, react_1.useCallback)((tab) => {
        setOpenCollapse((openCollapseArg) => (openCollapseArg === tab ? null : tab));
    }, [setOpenCollapse]);
    const controls = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Link_1.default, { onClick: () => handleOpenCollapse('sort') }, "Sort"),
        react_1.default.createElement(Link_1.default, { onClick: () => handleOpenCollapse('filter') }, "Filter"),
        react_1.default.createElement(TagColorsModalItem, null, "View Tag Colors")));
    return (react_1.default.createElement(Controls_1.default, null,
        react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2", className: "py-2 px-4" },
            react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2" },
                react_1.default.createElement(Text_1.default, { semibold: true, lg: true }, "Compare cubes"),
                react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "2", wrap: "wrap", justify: "start" },
                    react_1.default.createElement(Text_1.default, { semibold: true, md: true, className: "text-muted" }, "Base Cube:"),
                    ' ',
                    react_1.default.createElement(Link_1.default, { href: `/cube/list/${cubeAID}` },
                        cubeA.name,
                        " (",
                        cubeA.cardCount,
                        " cards)"),
                    ' ',
                    react_1.default.createElement(Text_1.default, { semibold: true, md: true, className: "text-muted" }, "Comparison Cube:"),
                    ' ',
                    react_1.default.createElement(Link_1.default, { href: `/cube/list/${cubeBID}` },
                        cubeB.name,
                        " (",
                        cubeB.cardCount,
                        " cards)"))),
            react_1.default.createElement(Layout_1.Flexbox, { direction: "row", wrap: "wrap", justify: "end", alignItems: "center" },
                react_1.default.createElement(ResponsiveDiv_1.default, { baseVisible: true, lg: true },
                    react_1.default.createElement(Button_1.default, { color: "secondary", onClick: toggleExpanded }, expanded ? react_1.default.createElement(octicons_react_1.ChevronUpIcon, { size: 32 }) : react_1.default.createElement(octicons_react_1.ThreeBarsIcon, { size: 32 }))),
                react_1.default.createElement(ResponsiveDiv_1.default, { lg: true },
                    react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "start", gap: "4", alignItems: "center" }, controls))),
            react_1.default.createElement(ResponsiveDiv_1.default, { baseVisible: true, lg: true },
                react_1.default.createElement(Collapse_1.default, { isOpen: expanded },
                    react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2", className: "py-2 px-4" }, controls))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(SortCollapse_1.default, { isOpen: openCollapse === 'sort' }),
                react_1.default.createElement(FilterCollapse_1.default, { isOpen: openCollapse === 'filter', showReset: true })))));
};
exports.default = CubeCompareNavbar;
